import dayjs from 'dayjs';

export function calculateAgeFromDateOfBirth(
    dateOfBirth: string,
    referenceDate: Date = new Date()
): number {
    const dob = dayjs(dateOfBirth);
    const ref = dayjs(referenceDate);
    let age = ref.year() - dob.year();
    if (ref.month() < dob.month() || (ref.month() === dob.month() && ref.date() < dob.date())) {
        age--;
    }
    return age;
}

export function calculateDateOfBirthFromAge(
    age: number,
    existingDateOfBirth?: string,
    referenceDate: Date = new Date()
): string {
    const birthYear = dayjs(referenceDate).year() - age;

    if (existingDateOfBirth) {
        return dayjs(existingDateOfBirth).year(birthYear).format('YYYY-MM-DD');
    }

    return dayjs().year(birthYear).month(0).date(1).format('YYYY-MM-DD');
}